var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import DeliverService from '../../api/DeliverService';
import Header from './Header.vue';
import GlobalVue from "../../globalVue";
import Table from './table.vue';
import TableList from "./component/TableListConfig.vue";
import _ from 'lodash';
import { numAdd } from '@/helper/calucate';
var DeliverList = (function (_super) {
    __extends(DeliverList, _super);
    function DeliverList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = DeliverService.getInstance();
        _this.fetchAction = _this.service.getList;
        _this.listData = [];
        _this.total = 0;
        _this.searchParams = null;
        _this.selectRows = [];
        _this.filter = {};
        _this.tableHeight = document.documentElement.clientHeight - 215;
        _this.sortColumns = [
            'c_time',
            'delivery_order_code',
            'order_status_name',
            'order_money',
            'order_amount',
            'order_oamount',
            'order_receive_amount',
            'order_detail_diff',
            'delivery_date',
            'expect_arrivedate',
            'organ_name',
            'customer',
            'shop_name',
            'order_detail_depot_names',
            'out_depot_name',
        ];
        _this.showSummary = true;
        _this.summaryDetail = {};
        return _this;
    }
    DeliverList.prototype.created = function () {
        console.log(3333, this.searchParams);
    };
    DeliverList.prototype.fetchCallBack = function (data) {
        var summaryDetail = {
            order_money: 0,
            order_amount: 0,
            order_oamount: 0,
            order_receive_amount: 0,
            order_detail_diff: 0,
        };
        data.data.forEach(function (item) {
            if (item.order_money !== '' && !isNaN(item.order_money)) {
                summaryDetail.order_money = numAdd(summaryDetail.order_money, parseFloat(item.order_money));
            }
            if (item.order_amount !== '' && !isNaN(item.order_amount)) {
                summaryDetail.order_amount = numAdd(summaryDetail.order_amount, parseFloat(item.order_amount));
            }
            if (item.order_oamount !== '' && !isNaN(item.order_oamount)) {
                summaryDetail.order_oamount = numAdd(summaryDetail.order_oamount, parseFloat(item.order_oamount));
            }
            if (item.order_receive_amount !== '' && !isNaN(item.order_receive_amount)) {
                summaryDetail.order_receive_amount = numAdd(summaryDetail.order_receive_amount, parseFloat(item.order_receive_amount));
            }
            if (item.order_detail_diff !== '' && !isNaN(item.order_detail_diff)) {
                summaryDetail.order_detail_diff = numAdd(summaryDetail.order_detail_diff, parseFloat(item.order_detail_diff));
            }
        });
        this.summaryDetail = summaryDetail;
    };
    DeliverList.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        this.$refs.cusHeader.moreSearchComHide();
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = this.getFormFilter(pager);
        this.service.getList(params).then(function (res) {
            var data = res.data.data;
            _.forEach(data, function (item) {
                item.listGoods = [];
                (item.items || []).push({ isBtn: true });
            });
            _this.listData = data;
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        });
    };
    DeliverList.prototype.getFormFilter = function (pager) {
        if (pager === void 0) { pager = {}; }
        var params = {
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
            s_time: typeof (this.searchParams.s_time) == "object" ? this.searchParams.s_time.format("yyyy-MM-dd") : this.searchParams.s_time,
            e_time: typeof (this.searchParams.e_time) == "object" ? this.searchParams.e_time.format("yyyy-MM-dd") : this.searchParams.e_time,
            business_id: this.searchParams.business,
            keyword_type: this.searchParams.searchType,
            keyword: this.searchParams.text,
            shop_id: this.searchParams.lsid,
            area_ids: this.searchParams.aid,
            order_type: this.searchParams.order_type || -1,
            delivery_order_status: this.searchParams.delivery_order_status,
            out_depot_id: this.searchParams.out_depot_id.length ? this.searchParams.out_depot_id.join(',') : -1,
            time_type: this.searchParams.time_type,
            is_print: this.searchParams.is_print,
            logistics_name: this.searchParams.logistics_name || ''
        };
        Object.assign(params, pager);
        return params;
    };
    DeliverList.prototype.getSelectIds = function () {
        var orderIds = this.selectRows.map(function (item) { return item.order_id; });
        return orderIds;
    };
    DeliverList.prototype.selectionChange = function (rows) {
        console.log(rows, 777);
        this.selectRows = rows;
    };
    DeliverList.prototype.pageChange = function (pager) {
        this.getList();
    };
    DeliverList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    DeliverList.prototype.search = function (searchParams) {
        var _this = this;
        this.searchParams = _.cloneDeep(searchParams);
        this.searchParams.delivery_order_status = Array.isArray(this.searchParams.delivery_order_status) ? this.searchParams.delivery_order_status.join(",") : this.searchParams.delivery_order_status;
        this.filter = {
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
            s_time: typeof (this.searchParams.s_time) == "object" && this.searchParams.s_time ? this.searchParams.s_time.format("yyyy-MM-dd") : this.searchParams.s_time,
            e_time: typeof (this.searchParams.e_time) == "object" && this.searchParams.e_time ? this.searchParams.e_time.format("yyyy-MM-dd") : this.searchParams.e_time,
            business_id: this.searchParams.business,
            keyword_type: this.searchParams.searchType,
            keyword: this.searchParams.text,
            shop_id: this.searchParams.lsid,
            area_ids: this.searchParams.aid,
            order_type: this.searchParams.order_type || -1,
            delivery_order_status: this.searchParams.delivery_order_status,
            out_depot_id: this.searchParams.out_depot_id.length ? this.searchParams.out_depot_id.join(',') : -1,
            time_type: this.searchParams.time_type,
            logistics_name: this.searchParams.logistics_name || ''
        };
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
    };
    DeliverList.prototype.listSearch = function () {
        this.search(this.searchParams);
    };
    DeliverList.prototype.addTab = function (options) {
        options.opener = this;
        options.showExist = true,
            GlobalVue.$emit('addTab', options);
    };
    DeliverList.prototype.getSummaries = function (param) {
        var _this = this;
        var sums = [];
        var setSummary = function (value, key) {
            var index = param.columns.findIndex(function (item) { return item.label === value; });
            if (index !== -1)
                sums[index] = _this.summaryDetail[key];
        };
        setSummary('送货金额', 'order_money');
        setSummary('采购量', 'order_amount');
        setSummary('送货量', 'order_oamount');
        setSummary('收货数量', 'order_receive_amount');
        setSummary('送货差异', 'order_detail_diff');
        if (!sums.length)
            return null;
        sums[0] = '合计';
        return sums;
    };
    DeliverList = __decorate([
        Component({
            components: {
                'cusHeader': Header,
                'listData': Table,
                TableList: TableList
            }
        })
    ], DeliverList);
    return DeliverList;
}(Vue));
export default DeliverList;
